const actions = {
  SEARCH_REQUEST: "CRAWLING_SETTING/SEARCH_REQUEST",
  SEARCH_SUCCESS: "CRAWLING_SETTING/SEARCH_SUCCESS",
  SEARCH_ERROR: "CRAWLING_SETTING/SEARCH_ERROR",

  CREATE_REQUEST: "CRAWLING_SETTING/CREATE_REQUEST",
  CREATE_SUCCESS: "CRAWLING_SETTING/CREATE_SUCCESS",
  CREATE_ERROR: "CRAWLING_SETTING/CREATE_ERROR",

  DETAIL_REQUEST: "CRAWLING_SETTING/DETAIL_REQUEST",
  DETAIL_SUCCESS: "CRAWLING_SETTING/DETAIL_SUCCESS",
  DETAIL_ERROR: "CRAWLING_SETTING/DETAIL_ERROR",

  UPDATE_REQUEST: "CRAWLING_SETTING/UPDATE_REQUEST",
  UPDATE_SUCCESS: "CRAWLING_SETTING/UPDATE_SUCCESS",
  UPDATE_ERROR: "CRAWLING_SETTING/UPDATE_ERROR",

  DELETE_REQUEST: "CRAWLING_SETTING/DELETE_REQUEST",
  DELETE_SUCCESS: "CRAWLING_SETTING/DELETE_SUCCESS",
  DELETE_ERROR: "CRAWLING_SETTING/DELETE_ERROR",

  EXECUTE_REQUEST: "CRAWLING_SETTING/EXECUTE_REQUEST",
  EXECUTE_SUCCESS: "CRAWLING_SETTING/EXECUTE_SUCCESS",
  EXECUTE_ERROR: "CRAWLING_SETTING/EXECUTE_ERROR",

  CANCEL_REQUEST: "CRAWLING_SETTING/CANCEL_REQUEST",
  CANCEL_SUCCESS: "CRAWLING_SETTING/CANCEL_SUCCESS",
  CANCEL_ERROR: "CRAWLING_SETTING/CANCEL_ERROR",

  GET_CURRENT_REQUEST: "CRAWLING_SETTING/GET_CURRENT_REQUEST",
  GET_CURRENT_SUCCESS: "CRAWLING_SETTING/GET_CURRENT_SUCCESS",
  GET_CURRENT_ERROR: "CRAWLING_SETTING/GET_CURRENT_ERROR",

  GET_HISTORIES_REQUEST: "CRAWLING_SETTING/GET_HISTORIES_REQUEST",
  GET_HISTORIES_SUCCESS: "CRAWLING_SETTING/GET_HISTORIES_SUCCESS",
  GET_HISTORIES_ERROR: "CRAWLING_SETTING/GET_HISTORIES_ERROR",

  IMPORT_REQUEST: "CRAWLING_SETTING/IMPORT_REQUEST",
  IMPORT_SUCCESS: "CRAWLING_SETTING/IMPORT_SUCCESS",
  IMPORT_ERROR: "CRAWLING_SETTING/IMPORT_ERROR",

  VALIDATE_SETTING_FILE_REQUEST: "CRAWLING_SETTING/VALIDATE_SETTING_FILE_REQUEST",
  VALIDATE_SETTING_FILE_SUCCESS: "CRAWLING_SETTING/VALIDATE_SETTING_FILE_SUCCESS",
  VALIDATE_SETTING_FILE_ERROR: "CRAWLING_SETTING/VALIDATE_SETTING_FILE_ERROR",

  RESET_DETAIL: "CRAWLING_SETTING/RESET_DETAIL",

  search: (payload) => ({
    type: actions.SEARCH_REQUEST,
    payload,
  }),

  create: (payload) => ({
    type: actions.CREATE_REQUEST,
    payload,
  }),

  getDetail: (payload) => ({
    type: actions.DETAIL_REQUEST,
    payload,
  }),

  update: (payload) => ({
    type: actions.UPDATE_REQUEST,
    payload,
  }),

  delete: (payload) => ({
    type: actions.DELETE_REQUEST,
    payload,
  }),

  execute: (payload) => ({
    type: actions.EXECUTE_REQUEST,
    payload,
  }),

  cancel: (payload) => ({
    type: actions.CANCEL_REQUEST,
    payload,
  }),

  getCurrent: (payload) => ({
    type: actions.GET_CURRENT_REQUEST,
    payload,
  }),

  getHistories: (payload) => ({
    type: actions.GET_HISTORIES_REQUEST,
    payload,
  }),

  importExcel: (payload) => ({
    type: actions.IMPORT_REQUEST,
    payload,
  }),

  validateSettingFile: (payload) => ({
    type: actions.VALIDATE_SETTING_FILE_REQUEST,
    payload,
  }),

  resetDetail: () => ({
    type: actions.RESET_DETAIL,
  }),
};

export default actions;
